import { render, staticRenderFns } from "./ExaminationPaper.vue?vue&type=template&id=604dbb5e&scoped=true"
import script from "./ExaminationPaper.vue?vue&type=script&lang=js"
export * from "./ExaminationPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604dbb5e",
  null
  
)

export default component.exports